import React, { useState, useEffect } from "react";
import "./Orders.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";

function createData1(
  productName,
  requested,
  unit,
  //  subtotal,
  stock,
  finalQty,
  discount,
  final,
  total,
) {
  return {
    productName,
    requested,
    unit,
    // subtotal,
    stock,
    finalQty,
    discount,
    final,
    total,
  };
}

const rows1 = [
  createData1("Exterior Paint 20L", "10", "₹2,150", "₹21,500", "45"),
  createData1("Exterior Paint 20L", "10", "₹2,150", "₹21,500", "45"),
  createData1("Exterior Paint 20L", "10", "₹2,150", "₹21,500", "45"),
];

export const ManageOrders = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { Id } = location?.state || "";
  console.log("Id", Id);
  const [loading, setLoading] = useState(false);
  const [manageOrderDetails, setManageOrderDetails] = useState({});
  const [orderTable, setOrderTable] = useState([]);
  const [success, setSuccess] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [error, setError] = useState({});

  async function fetchManageOrderDetails(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/distributor/orders/${Id}/`);
      if (response.data.status === "Success" || response.status === 200) {
        setManageOrderDetails(response.data?.data);
        // setOrderTable(response.data.data.order_products);
        setOrderTable(
          response.data.data.order_products.map((item) => ({
            ...item,
            finalQty: "",
            subTotal: 0,
            gstPercent: 0,
            cgsg: 0,
            totalAfterTax: 0,
            discount: item.discount ?? "",
            finalTotal: 0,
          })),
        );
        console.log("Order details fetched successfully!");
      }
    } catch (error) {
      toast.error(error.response.data.message || "failed to fetch details!");
      console.log("failed to fetch details!");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchManageOrderDetails(Id);
  }, []);

  // function handleFinalQtyChange(id, value) {
  //   setOrderTable((prev) =>
  //     prev.map((row) =>
  //       row.id === id
  //         ? {
  //             ...row,
  //             finalQty: value,
  //             subTotal: Number(value) * Number(row.price),
  //           }
  //         : row,
  //     ),
  //   );
  // }

  // function handleGstPercent(id, value) {
  //   setOrderTable((prev) =>
  //     prev.map((row) =>
  //       row.id === id
  //         ? {
  //             ...row,
  //             gstPercent: value,
  //             cgsg: (Number(value) / 100) * Number(row.subTotal),
  //             totalAfterTax:
  //               Number(row.subTotal) +
  //               (Number(value) / 100) * Number(row.subTotal),
  //           }
  //         : row,
  //     ),
  //   );
  // }
  // function handleDiscountChange(id, value) {
  //   setOrderTable((prev) =>
  //     prev.map((row) =>
  //       row.id === id
  //         ? {
  //             ...row,
  //             discount: value,
  //             finalTotal:
  //               Number(row.totalAfterTax) -
  //               (Number(value) / 100) * Number(row.totalAfterTax),
  //           }
  //         : row,
  //     ),
  //   );
  // }
  function calculateRow(row) {
    const finalQty = Number(row.finalQty) || 0;
    const price = Number(row.price) || 0;
    const gstPercent = Number(row.gstPercent) || 0;
    const discount = Number(row.discount) || 0;

    const subTotal = Number((finalQty * price).toFixed(2));

    const taxAmount = Number(((gstPercent / 100) * subTotal).toFixed(2)); // taxAmount means cgst and sgst

    const totalAfterTax = Number((subTotal + taxAmount).toFixed(2));

    const discountAmount = Number(
      ((discount / 100) * totalAfterTax).toFixed(2),
    );

    const finalTotal = Number((totalAfterTax - discountAmount).toFixed(2));

    return {
      ...row,
      subTotal,
      cgsg: taxAmount,
      totalAfterTax,
      finalTotal,
    };
  }
  function handleFinalQtyChange(id, value) {
    setOrderTable((prev) =>
      prev.map((row) =>
        row.id === id ? calculateRow({ ...row, finalQty: value }) : row,
      ),
    );
  }
  function handleGstPercent(id, value) {
    setOrderTable((prev) =>
      prev.map((row) =>
        row.id === id ? calculateRow({ ...row, gstPercent: value }) : row,
      ),
    );
  }
  function handleDiscountChange(id, value) {
    setOrderTable((prev) =>
      prev.map((row) =>
        row.id === id ? calculateRow({ ...row, discount: value }) : row,
      ),
    );
  }
  // send updated order table
  async function handleOrderTableUpdate() {
    try {
      setLoading(true);
      const payload = {
        products: orderTable?.map((item) => ({
          id: item.id, // from API
          qty: item.qty, // from API
          price: item.price, // from API

          // final_quantity_dispatch: Number(finalQty) || item.qty,
          // gst: Number(gstPercent) || 0,
          // cgst_sgst: cgsg || 0,
          // total_after_tax: totalAfterTax || 0,
          // discount: Number(discount) || 0,
          // final: total || 0,
          final_quantity_dispatch: Number(item.finalQty) || item.qty,
          gst: Number(item.gstPercent) || 0,
          cgst_sgst: item.cgsg || 0,
          total_after_tax: item.totalAfterTax || 0,
          discount: Number(item.discount) || 0,
          final: item.finalTotal || 0,
        })),
      };

      console.log("PAYLOAD SENT:", payload);
      const response = await axiosInstance.put(
        `distributor/order-item-update/${Id}/`,
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        console.log("order table data updated successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to updated order table!",
      );
      setSuccess(false);
      console.log("failed to updated order table!");
    } finally {
      setLoading(false);
    }
  }
  //  To display below table
  const totalAmount = orderTable.reduce((sum, row) => sum + row.subTotal, 0);
  const totalTax = orderTable.reduce((sum, row) => sum + row.cgsg, 0);
  const totalAfterTaxAll = orderTable.reduce(
    (sum, row) => sum + row.totalAfterTax,
    0,
  );
  // const totalDiscount = orderTable.reduce(
  //   (sum, row) => sum + (Number(row.discount) / 100) * row.totalAfterTax,
  //   0
  // );
  const finalTotalAll = orderTable.reduce(
    (sum, row) => sum + row.finalTotal,
    0,
  );

  const formik = useFormik({
    initialValues: {
      waybill: null,
      due_date: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formData = new FormData();
        if (values.waybill) {
          formData.append("waybill", values.waybill);
        }
        formData.append("due_date", values.due_date);
        const response = await axiosInstance.patch(
          `distributor/orders/${Id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.status === "success" || response.status === 200) {
          resetForm();
          console.log("way bill and date submitted successfully!");
          setSuccess(true);
        }
      } catch (error) {
        toast.error(
          error.response.data.message || "failed to submit way bill and date ",
        );
        console.log("failed to submit way bill and date ");
      } finally {
        setLoading(false);
      }
    },
  });
  // generate invoice api calling internally
  // async function handleGenetate()
  async function handleGenerateInvoice() {
    try {
      const newErrors = {}; // for showing erros separetly for each field

      if (!invoiceNumber) {
        newErrors.invoiceNumber = "Invoice Number is required";
      }
      if (!invoiceDate) {
        newErrors.invoiceDate = "Invoice Date is required";
      }

      setError(newErrors);

      if (Object.keys(newErrors).length > 0) return;

      setLoading(true);

      const payload = {
        order_id: Id,
        payment_method: manageOrderDetails.payment_type,
        invoice_number: invoiceNumber,
        invoice_date: invoiceDate,
      };
      const response = await axiosInstance.post(
        "/distributor/order-generate-invoice/",
        payload,
      );
      if (response.data.status === "success" || response.status === 200) {
        console.log("generate invoice payload send successfully!");
        handleOrderTableUpdate();
        formik.submitForm();
        navigate("/state-orders");
      }
    } catch (error) {
      console.log("generate invoice payload failed to send!");
    } finally {
      setLoading(false);
    }
  }

  // async function handleGenerateInvoice() {
  //   try {
  //     await handleOrderTableUpdate();
  //     await formik.submitForm();
  //     await handleGenetate();

  //     navigate("/state-orders");
  //   } catch (err) {
  //     console.log("Error in generating invoice", err);
  //     toast.error("Invoice generation failed");
  //   }
  // }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />

      <div className="ordersContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/state-orders" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="inventoryTitle">
              #ORD-{manageOrderDetails.order_id}
            </div>
          </div>
          <div className="inventorySubtitle">
            Review and process this sub-distributor order
          </div>
          {/* cards section  */}
          <div className="manageCardsGrid">
            <div className="manageCard">
              <div>Sub-distributor</div>
              <div>
                {manageOrderDetails.ordered_by_detail?.type === "subdistributor"
                  ? manageOrderDetails.ordered_by_detail?.business_name
                  : manageOrderDetails.ordered_by_detail?.agent_name}
              </div>
            </div>
            <div className="manageCard">
              <div>Order Date</div>
              <div>{manageOrderDetails.order_date}</div>
            </div>
            <div className="manageCard">
              <div>Payment Type</div>
              <div>{manageOrderDetails.payment_type}</div>
            </div>
            <div className="manageCard">
              <div>Order Amount</div>
              <div>{manageOrderDetails.total_amount}</div>
            </div>
            <div className="manageCard">
              <div>Amount Paid</div>
              <div>{manageOrderDetails.amount_paid}</div>
            </div>
            <div className="manageCard">
              <div>Due Amount</div>
              <div>{manageOrderDetails.due_amount}</div>
            </div>
          </div>
          {/* wave and due  */}
          <div>
            {/* for calling api using formik */}
            <form
              onSubmit={formik.handleSubmit}
              className="manageInputContainer"
            >
              <div className="manageInput">
                <label>Wave Bill</label>
                <div>
                  <input
                    type="file"
                    onChange={(event) => {
                      formik.setFieldValue(
                        "waybill",
                        event.currentTarget.files[0],
                      );
                    }}
                    name="waybill"
                  />
                </div>
              </div>
              <div className="manageInput">
                <label>Due Date</label>
                <div>
                  {" "}
                  <input
                    type="date"
                    className="py-2"
                    onChange={formik.handleChange}
                    name="due_date"
                  />
                </div>
              </div>
            </form>

            <div className="manageInputContainer mt-3">
              <div className="manageInput">
                <label>
                  Invoice Number <span className="text-danger">*</span>
                </label>
                <div>
                  {" "}
                  <input
                    type="text"
                    placeholder="Enter Invoice Number"
                    className="py-2"
                    
                    onChange={(e) => {
                      setInvoiceNumber(e.target.value);
                      setError((prev) => ({
                        ...prev,
                        invoiceNumber: "",
                      }));
                    }}
                    value={invoiceNumber}
                  />
                  {error.invoiceNumber && (
                    <div style={{ fontSize: "14px", color: "red" }}>
                      {error.invoiceNumber}
                    </div>
                  )}
                </div>
              </div>

              <div className="manageInput">
                <label>
                  Invoice Date <span className="text-danger">*</span>
                </label>
                <div>
                  {" "}
                  <input
                    type="date"
                    className="py-2"
                    onChange={(e) => {
                      setInvoiceDate(e.target.value);
                      setError((prev) => ({
                        ...prev,
                        invoiceDate: "",
                      }));
                    }}
                    value={invoiceDate}
                  />
                  {error.invoiceDate && (
                    <div style={{ fontSize: "14px", color: "red" }}>
                      {error.invoiceDate}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* table  */}
          <div className="titleOrderList">Ordered Products</div>

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Product Code</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">UOM</TableCell>
                    <TableCell align="left">Requested Qty</TableCell>
                    <TableCell align="left">Qty</TableCell>
                    <TableCell align="left">Price/Unit (₹)</TableCell>
                    <TableCell align="left">Total Price</TableCell>
                    <TableCell align="left">GST %</TableCell>
                    <TableCell align="left">CGST + SGST</TableCell>
                    <TableCell align="left">Total After Tax</TableCell>
                    <TableCell align="left">Discount</TableCell>
                    <TableCell align="left">Final Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderTable.length > 0 ? (
                    orderTable.map((orderTable) => (
                      <TableRow
                        key={orderTable.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell component="th" scope="row">
                          {orderTable.product_name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {orderTable.product_code}
                        </TableCell>
                        <TableCell align="left">{orderTable.uom}</TableCell>
                        <TableCell align="left">{orderTable.qty}</TableCell>
                        <TableCell align="left">
                          <span className="addModalQtyInput">
                            {/* <input
                              type="text"
                              value={finalQty}
                              onChange={(e) =>
                                handleFinalQtyChange(
                                  e.target.value,
                                  orderTable.price
                                )
                              }
                            /> */}
                            <input
                              type="number"
                              value={orderTable.finalQty}
                              onChange={(e) =>
                                handleFinalQtyChange(
                                  orderTable.id,
                                  e.target.value,
                                )
                              }
                            />
                          </span>
                        </TableCell>
                        <TableCell align="left">{orderTable.price}</TableCell>
                        <TableCell align="left">
                          {orderTable.subTotal}
                        </TableCell>
                        <TableCell align="left">
                          <span className="addModalQtyInput">
                            {/* <input
                              type="text"
                              value={gstPercent}
                              onChange={(e) => handleGstPercent(e.target.value)}
                            /> */}
                            <input
                              type="number"
                              value={orderTable.gstPercent}
                              onChange={(e) =>
                                handleGstPercent(orderTable.id, e.target.value)
                              }
                            />
                          </span>
                        </TableCell>

                        <TableCell align="left">{orderTable.cgsg}</TableCell>
                        <TableCell align="left">
                          {orderTable.totalAfterTax}
                        </TableCell>
                        <TableCell align="left">
                          <span className="addModalQtyInput">
                            {/* <input
                              type="text"
                              value={discount}
                              onChange={(e) =>
                                handleDiscountChange(e.target.value)
                              }
                            /> */}
                            <input
                              type="number"
                              value={orderTable.discount}
                              onChange={(e) =>
                                handleDiscountChange(
                                  orderTable.id,
                                  e.target.value,
                                )
                              }
                            />
                          </span>
                        </TableCell>

                        {/* <TableCell align="left">{total || "0"}</TableCell> */}
                        <TableCell align="left">
                          {orderTable.finalTotal}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={8}>
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Totals */}
          {/* <div className="addModalTotalContainer">
            <div>
              <div className="addModalContent">
                <span>Total Amount :</span>
                <span>{subTotal || "0"}/-</span>
              </div>

              <div className="addModalContent">
                <span>Tax Amount :</span>
                <span>{cgsg || "0"}/-</span>
              </div>
              <div className="addModalContent">
                <span>Total After Tax :</span>
                <span>{totalAfterTax || "0"}/-</span>
              </div>
              <div className="addModalContent">
                <span>Discount :</span>
                <span>{discount || "0"}%</span>
              </div>
              <div className="addModalContent">
                <span>Final Total :</span>
                <span>{total || "0"}/-</span>
              </div>
            
            </div>
          </div> */}
          <div className="addModalTotalContainer">
            <div>
              <div className="addModalContent">
                <span>Total Amount :</span>
                <span>{totalAmount}/-</span>
              </div>

              <div className="addModalContent">
                <span>Tax Amount :</span>
                <span>{totalTax}/-</span>
              </div>
              <div className="addModalContent">
                <span>Total After Tax :</span>
                <span>{totalAfterTaxAll}/-</span>
              </div>
              {/* <div className="addModalContent">
                <span>Discount :</span>
              <span>{totalDiscount}/-</span>
              </div> */}
              <div className="addModalContent">
                <span>Final Total :</span>
                <span>{finalTotalAll}/-</span>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "20px" }}
            >
              {/* <button className="addBtnCancel">Cancel</button> */}
              <button className="addBtnSave" onClick={handleGenerateInvoice}>
                Generate Invoice
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
